import { exportAsImage } from "../../utils/exportAsImage";

export default function MedalSummary({ results }) {
  const medalCounts = { Gold: 0, Silver: 0, Bronze: 0 };
  results.forEach(r => {
    if (r.medal) medalCounts[r.medal] = (medalCounts[r.medal] || 0) + 1;
  });

  const ageGroups = {};
  results.forEach(r => {
    if (!r.ageGroup) return;
    if (!ageGroups[r.ageGroup]) {
      ageGroups[r.ageGroup] = { Gold: 0, Silver: 0, Bronze: 0 };
    }
    if (r.medal) {
      ageGroups[r.ageGroup][r.medal] =
        (ageGroups[r.ageGroup][r.medal] || 0) + 1;
    }
  });

  // enforce order
  const orderedGroups = [
    "BU9", "GU9",
    "BU11", "GU11",
    "BU13", "GU13",
    "BU15", "GU15",
    "BU17", "GU17",
  ];

  return (
    <section>
      <div className="flex items-center justify-end mb-4">
        <button
          onClick={() => exportAsImage("medal-summary-section", "medal_summary")}
          className="px-2 py-1 bg-blue-500 text-white rounded"
        >
          Save as Image
        </button>
      </div>
      <div id="medal-summary-section" className="space-y-6">
        {/* Total medals */}
        <table className="w-full border-collapse border border-gray-300 text-center">
          <thead className="sticky top-0 bg-gray-100 z-10">
            <tr className="bg-gray-100">
              <th className="border border-gray-300 p-2">🥇 Gold</th>
              <th className="border border-gray-300 p-2">🥈 Silver</th>
              <th className="border border-gray-300 p-2">🥉 Bronze</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="border border-gray-300 p-2">{medalCounts.Gold}</td>
              <td className="border border-gray-300 p-2">{medalCounts.Silver}</td>
              <td className="border border-gray-300 p-2">{medalCounts.Bronze}</td>
            </tr>
          </tbody>
        </table>

        {/* Breakdown by age group */}
        <table className="w-full border-collapse border border-gray-300 text-center">
          <thead className="sticky top-0 bg-gray-100 z-10">
            <tr className="bg-gray-100">
              <th className="border border-gray-300 p-2">Age Group</th>
              <th className="border border-gray-300 p-2">🥇 Gold</th>
              <th className="border border-gray-300 p-2">🥈 Silver</th>
              <th className="border border-gray-300 p-2">🥉 Bronze</th>
            </tr>
          </thead>
          <tbody>
            {orderedGroups.map(group => {
              const counts = ageGroups[group];
              if (!counts) return null;
              if (counts.Gold === 0 && counts.Silver === 0 && counts.Bronze === 0) {
                return null; // skip groups with no medals
              }
              return (
                <tr key={group}>
                  <td className="border border-gray-300 p-2 font-medium">{group}</td>
                  <td className="border border-gray-300 p-2">{counts.Gold}</td>
                  <td className="border border-gray-300 p-2">{counts.Silver}</td>
                  <td className="border border-gray-300 p-2">{counts.Bronze}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </section>
  );
}
